import styled from '@emotion/styled'

export const InstructionsList = styled.ul`
  list-style-type: disc;
`
